import React, { useEffect } from 'react';
import { AppBar, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { MenuRounded } from '@mui/icons-material';
import { bool, func } from 'prop-types';

// utils
import { useAppTitle } from 'hooks';

// Components
import Tabs from './tabs/Tabs';
import AddMenu from './add-menu/AddMenuConnector';
import Notifications from '../notifications/views/Notifications.connector';
import SideDrawer from './side-drawer/SideDrawerConnector';

const Navigation = ({ isNavHidden, setIsNavDrawerOpen }) => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });

  // reset everything if cycling between views
  useEffect(() => {
    setIsNavDrawerOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lgUp]);

  const title = useAppTitle();

  return (
    <AppBar
      elevation={0}
      sx={{
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        backgroundColor: { xs: 'primary.dark', lg: 'surface.white' },
        borderBottom: { lg: '1px solid' },
        borderBottomColor: { lg: 'graphic.light' },
        boxShadow: { lg: 'none' },
        display: isNavHidden ? 'none' : 'flex',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        height: { xs: 56, lg: 48 },
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        px: { xs: 2, lg: 0 },
        py: 0,
      }}
    >
      <Toolbar disableGutters variant={lgUp ? 'dense' : 'regular'}>
        <IconButton
          aria-label="Open drawer"
          className="heap-menu"
          // edge has available options of "start" or false, so && works here
          edge={!lgUp && 'start'}
          onClick={() => setIsNavDrawerOpen(true)}
          size="large"
          sx={{
            '&:hover': {
              backgroundColor: 'secondary.light',
            },
            borderRadius: { lg: 0 },
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            color: { xs: 'surface.white', lg: 'secondary.main' },
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            marginRight: { xs: 0, sm: 1.5, lg: 0 },
          }}
        >
          <MenuRounded />
        </IconButton>
        <Typography
          noWrap
          sx={{
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            color: { xs: 'surface.white', lg: 'primary.dark' },
            mb: 0,
            ml: 0,
            mr: 'auto',
            // marginTop on the section title gives the illusion of centering
            mt: 0.5,
          }}
          variant="h6"
        >
          {title}
        </Typography>
        {lgUp && <Tabs />}
        <Notifications />
        <AddMenu />
        <SideDrawer />
      </Toolbar>
    </AppBar>
  );
};

Navigation.propTypes = {
  isNavHidden: bool.isRequired,
  setIsNavDrawerOpen: func.isRequired,
};

export default Navigation;
